export enum GISCreditTypes {

    Shared = 0,
    Individual = 1

}

export interface IGISUsageHistoryItemResponse {

    ID: number;
    CreditType: GISCreditTypes;
    Credited: boolean;
    DateTimeCreated: Date;
    Key: string;
    Address: string;
    Refunded: boolean;
    // FixDates();

}

export class GISUsageHistoryItemResponse implements IGISUsageHistoryItemResponse {

    ID: number;
    CreditType: GISCreditTypes;
    Credited: boolean;
    DateTimeCreated: Date;
    Key: string;
    Address: string;
    Refunded: boolean;

    // FixDates() {
    //     this.DateTimeCreated = new Date(this.DateTimeCreated);
    // }

}

export class GISUsageHistoryItemResponseArray extends Array<GISUsageHistoryItemResponse> {

    constructor(...items: GISUsageHistoryItemResponse[]) {
        super(...items);
        Object.setPrototypeOf(this, GISUsageHistoryItemResponseArray.prototype);
    }

    public InitFromJSON() {

        if (this.length == 0)
            return;

        this.forEach((item) => {
            Object.setPrototypeOf(item, GISUsageHistoryItemResponse.prototype);
            // item.FixDates();
        })
    }

}